import { render, staticRenderFns } from "./EmployeeStatus.vue?vue&type=template&id=168b31b8&scoped=true&"
import script from "./EmployeeStatus.vue?vue&type=script&lang=ts&"
export * from "./EmployeeStatus.vue?vue&type=script&lang=ts&"
import style0 from "./EmployeeStatus.vue?vue&type=style&index=0&id=168b31b8&prod&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "168b31b8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VChip,VIcon,VRow,VSheet,VTooltip})
